module.exports = __webpack_public_path__ + "img/changan.7a486b73.png";